import { createAsyncThunk, createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { selectCurrentToken } from "../../../redux/reducers/authSlice";
import { createSelector } from 'reselect';
import http from '../../../lib/http/index.js';
import { useSelector } from "react-redux";

export const getContratosData = createAsyncThunk('GET_CONTRATOS', async (payload, thunkAPI) => {

    const contratos = await http.TABLE('/contratos');
    const titularidades = await http.TABLE('/titularidadcontratos');
    const campanas = await http.TABLE('/campanas');
    //const pagos = await http.TABLE('/pagos');
    const personas = await http.TABLE('/personas');
    const rolesPersonasMap = await http.TABLE('/personasrolesmap');
    const documentos = (await http.GET('/documentos')).body;
    const clasesContratos = (await http.TABLE('/clasesContrato')).body;
    const tiposCampana = (await http.TABLE('/tipos-campana')).body;
    const indices = (await http.TABLE('/indices')).body;
    const roles = (await http.TABLE('/roles')).body;
    const funcHistoria = (await http.GET('/funchistoriacontrato')).body;

    const data = {
        contratos: contratos.body,
        titularidades: titularidades.body,
        campanas: campanas.body,
       // pagos: pagos.body,
        personas: personas.body,
        rolesPersonasMap: rolesPersonasMap.body,
        documentos,
        clasesContratos,
        tiposCampana,
        indices,
        roles,
        funcHistoria,
    };
    return data;
});

export const selectCachedData = state => state.contratos.data;
export const addContrato = createAsyncThunk('POST_CONTRATOS', async (payload, thunkAPI) => {
    let res = (await http.POST('/contratos', payload)).body;
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res;
});
export const editContrato = createAsyncThunk('PUT_CONTRATOS', async (payload, thunkAPI) => {
    const res = (await http.PUT('/contratos', payload)).body;
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res

});
export const firmarContrato = createAsyncThunk('PUT_CONTRATOS', async (payload, thunkAPI) => {
    const res = (await http.PUT('/firmar-contratos', payload)).body;
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res

});
export const deleteContrato = createAsyncThunk('DELETE_CONTRATOS', async (payload, thunkAPI) => {
    const res = (await http.DELETE('/contratos', payload)).body;
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res

});
export const addDoc = createAsyncThunk('POST_DOCUMENTOS', async (payload, thunkAPI) => {
    const token = useSelector(selectCurrentToken)
    let res = (await fetch((process.env.REACT_APP_BACKEND_URL + '/documentos'), {
        method: 'POST',
        body: payload,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }));
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res;
});
export const delDoc = createAsyncThunk('DELETE_DOCUMENTOS', async (payload, thunkAPI) => {
    const res = (await http.DELETE('/documentos', payload)).body;
    await thunkAPI.dispatch(getContratosData()).unwrap();
    return res
});
export const getInfoContrato = createAsyncThunk('GET_INFO', async (payload, thunkAPI) => {
    const res = (await http.GET(`/infocontrato/${payload}`)).body
    return res
});
const initialState = {
    fetching: 0,
    error: null,
    message: null,
    data: {},
    infoContrato: {}
};

const contratosSlice = createSlice({
    name: 'contratos',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
        resetData: (state, action) => ({ ...initialState }),
    },
    extraReducers: {
        [getContratosData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, }),
        [getContratosData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action.error.message }),
        [getContratosData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),

        [addContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la creación!" }),
        [addContrato.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Contrato creado!" : null,
            error: action.payload.status != 200 ? "No se pudo crear el Contrato!" : null,
        }),
        [editContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [editContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la edición!" }),
        [editContrato.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Contrato editado!" : null,
            error: action.payload.status != 200 ? "No se pudo editar el Contrato!" : null,
        }),
        [firmarContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [firmarContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la firma!" }),
        [firmarContrato.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Contrato firmado!" : null,
            error: action.payload.status != 200 ? "No se pudo firmar el Contrato!" : null,
        }),

        [deleteContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [deleteContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la eliminación!" }),
        [deleteContrato.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Contrato eliminado!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar el Contrato!" : null,
        }),
        [delDoc.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [delDoc.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la eliminación del documento!" }),
        [delDoc.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Documento eliminado!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar el Documento!" : null,
        }),
        [addDoc.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addDoc.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la carga del documento!" }),
        [addDoc.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Documento cargado!" : null,
            error: action.payload.status != 200 ? "No se pudo cargar el archivo!" : null,
        }),
        [getInfoContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, infoContrato: null }),
        [getInfoContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getInfoContrato.fulfilled]: (state, action) => ({ ...state, infoContrato: action.payload, fetching: state.fetching - 1 }),
    },
})

export const { cleanError, cleanMessage, resetData } = contratosSlice.actions
export default contratosSlice.reducer;